import { FC, memo, useState } from 'react'
import { Checkbox, CheckboxGroup, Input, InputGroup } from 'rsuite'
import SearchIcon from '@rsuite/icons/Search'
import useTranslation from 'next-translate/useTranslation'

import { DataItemType } from '../../utils/types/rsuite'

import styles from '../../styles/CheckboxFilterMobile.module.less'

interface CheckboxFilterMobileProps {
  data: DataItemType[]
  value: string[]
  onChange: (value: string[]) => void
  onSearch: (value: string) => void
  renderExtraFooter?: () => React.ReactNode
}

const CheckboxFilterMobile: FC<CheckboxFilterMobileProps> = (props) => {
  const { data, value, onChange, onSearch, renderExtraFooter } = props

  const [searchQuery, setSearchQuery] = useState('')

  const { t } = useTranslation('products')

  return (
    <>
      <InputGroup className={styles['search-input']}>
        <InputGroup.Addon>
          <SearchIcon />
        </InputGroup.Addon>
        <Input
          placeholder="Search"
          value={searchQuery}
          onChange={(searchValue) => {
            setSearchQuery(searchValue)
            onSearch(searchValue) // Pass search data to instantsearch
          }}
        />
      </InputGroup>

      <div className={styles['items-list']}>
        <CheckboxGroup
          name="checkbox-group"
          value={value}
          onChange={(checkedValues) => {
            onChange(checkedValues as string[])
          }}
        >
          {data.map((item) => (
            <div
              className={styles['filter-item']}
              key={item.value}
            >
              <Checkbox
                value={item.value}
                className={styles['item-checkbox']}
              >
                <span className={styles['item-name']}>{item.label}</span>
              </Checkbox>
            </div>
          ))}
          {data.length === 0 && <p className={styles['no-results']}>{t('No results found')}</p>}
        </CheckboxGroup>
        {renderExtraFooter && renderExtraFooter()}
      </div>
    </>
  )
}

export default memo(
  CheckboxFilterMobile,
  (prevProps, nextProps) => prevProps.value === nextProps.value
  && prevProps.data.length === nextProps.data.length,
)
